import { FiltersGroupModule } from './../../../widgets/filters/filters-group/filters-group.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
	DxDataGridModule, DxChartModule, DxBulletModule, DxTemplateModule, DxPopupModule, DxPivotGridModule, DxSwitchModule,

} from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { CapacityOverviewComponent } from './capacity-overview.component';
import { CapacityService } from '../capacity.service';
import { DxoFieldChooserModule, DxoScrollingModule } from 'devextreme-angular/ui/nested';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';
import { CapacityOverviewRoutingModule } from './capacity-overview-routing.module';
import { BookmarksControlsComponent } from 'src/app/widgets/bookmark-new/bookmarks-controls/bookmarks-controls.component';
import { HelpButtonComponent } from 'src/app/widgets/help-button/help-button.component';
import { ContainerComponent } from 'src/app/components/container/container.component';
import { DxTableControllerDirective } from 'src/app/directives/dx-table-controller.directive';
import { WebExportModule } from 'src/app/widgets/web-export/web.export.module';

@NgModule({
	declarations: [ CapacityOverviewComponent ],
	imports: [
		CommonModule,

		DxTableControllerDirective,

		DxDataGridModule,
		DxChartModule,
		DevEpressCommonModule,
		DxBulletModule,
		DxTemplateModule,
		DxPopupModule,
		DxPivotGridModule,
		DxoFieldChooserModule,
		DxoScrollingModule,
		DxSwitchModule,

		CapacityOverviewRoutingModule,

		ContainerComponent,
		// BookmarkModule,
		BookmarkNewComponent,
		BookmarksControlsComponent,
		HelpButtonComponent,
		FiltersGroupModule,

		FormsModule,
		ReactiveFormsModule,WebExportModule
	], providers: [ CapacityService ]
})
export class CapacityOverviewModule { }
